import * as React from "react";
import type { SVGProps } from "react";
const SvgSliders = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3 21a1 1 0 1 0 2 0zm2-7a1 1 0 1 0-2 0zm-2-4a1 1 0 1 0 2 0zm2-7a1 1 0 0 0-2 0zm6 18a1 1 0 1 0 2 0zm2-9a1 1 0 1 0-2 0zm-2-4a1 1 0 1 0 2 0zm2-5a1 1 0 1 0-2 0zm6 18a1 1 0 1 0 2 0zm2-5a1 1 0 1 0-2 0zm-2-4a1 1 0 1 0 2 0zm2-9a1 1 0 1 0-2 0zM1 13a1 1 0 1 0 0 2zm6 2a1 1 0 1 0 0-2zm2-8a1 1 0 0 0 0 2zm6 2a1 1 0 1 0 0-2zm2 6a1 1 0 1 0 0 2zm6 2a1 1 0 1 0 0-2zM5 21v-7H3v7zm0-11V3H3v7zm8 11v-9h-2v9zm0-13V3h-2v5zm8 13v-5h-2v5zm0-9V3h-2v9zM1 15h6v-2H1zm8-6h6V7H9zm8 8h6v-2h-6z"
    />
  </svg>
);
export default SvgSliders;
